export enum REPORTSOURCES{
    SYSTEM="SYSTEM",
    FIXED_PORTAL="FIXED_PORTAL",
    HANDHELD="HANDHELD",
    WEB_APP="WEB_APP",
    PRINTER="PRINTER",
    DESKTOP_APP="DESKTOP_APP",
    POS_DEVICE="POS_DEVICE"
}